export default __webpack_public_path__ + "static/media/image-error.a5552080.png";